(function () {
  'use strict';

  var config = window.__bundleStep2Config || {};
  var productHandle = config.productHandle;
  var compareAtPerPair = config.compareAtPerPair || 0;

  var skeletonEl = document.getElementById('bf2-skeleton');
  var slotsEl = document.getElementById('bf2-slots');
  var errorBanner = document.getElementById('bf2-error-banner');
  var slotTemplate = document.getElementById('bf2-slot-template');

  var MAX_SLOTS = 3;
  var DISCOUNT_PCTS = { 1: 38, 2: 46, 3: 55 };

  var product = null;
  var colorIdx = 0;
  var sizeIdx = 1;
  var variantLookup = {};
  var firstAvailableVariant = null;

  // Serializes every cart mutation so rapid edits (e.g. two slot changes in
  // quick succession) can't race each other or act on a stale line index.
  var cartQueueChain = Promise.resolve();
  function enqueue(task) {
    var result = cartQueueChain.then(task, task);
    cartQueueChain = result.then(function () {}, function () {});
    return result;
  }

  function showError(message) {
    errorBanner.textContent = message;
    errorBanner.hidden = false;
  }

  function clearError() {
    errorBanner.hidden = true;
    errorBanner.textContent = '';
  }

  function formatPrice(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js').then(function (res) {
      if (!res.ok) throw new Error('product_fetch_failed');
      return res.json();
    });
  }

  function getCart() {
    return fetch('/cart.js').then(function (res) {
      if (!res.ok) throw new Error('cart_fetch_failed');
      return res.json();
    });
  }

  function addToCart(variantId, slot) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: { _slot: String(slot) } })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () { return {}; }).then(function (err) {
          throw new Error(err.description || 'add_to_cart_failed');
        });
      }
      return res.json();
    });
  }

  // Shopify's /cart/change.js cannot reassign a line's variant by combining
  // `line` with a different `id` (rejected server-side). Swapping a slot's
  // variant is a two-step add-then-remove: add the new variant under the same
  // `_slot` property, then remove the old line once re-resolved by position.
  function removeLine(line) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () { return {}; }).then(function (err) {
          throw new Error(err.description || 'remove_line_failed');
        });
      }
      return res.json();
    });
  }

  function getOptionIndex(prod, name) {
    var idx = prod.options.findIndex(function (o) {
      return o.name.toLowerCase() === name;
    });
    return idx === -1 ? null : idx;
  }

  function buildVariantLookup(prod) {
    var lookup = {};
    prod.variants.forEach(function (v) {
      var color = v.options[colorIdx];
      var size = v.options[sizeIdx];
      if (!lookup[color]) lookup[color] = {};
      lookup[color][size] = v;
    });
    return lookup;
  }

  function lineSlot(line) {
    return line.properties && line.properties._slot;
  }

  function lineColorSize(line) {
    var color = null;
    var size = null;
    (line.options_with_values || []).forEach(function (ov) {
      var n = ov.name.toLowerCase();
      if (n === 'color') color = ov.value;
      if (n === 'size') size = ov.value;
    });
    if (color === null) color = line.variant_options[colorIdx];
    if (size === null) size = line.variant_options[sizeIdx];
    return { color: color, size: size };
  }

  function slotLinesFromCart(cart) {
    return cart.items.filter(function (i) { return lineSlot(i); });
  }

  function renderSlotCard(line, slotNumber) {
    var frag = slotTemplate.content.cloneNode(true);
    var card = frag.querySelector('[data-bf2-slot]');
    card.dataset.slot = slotNumber;

    var thumb = frag.querySelector('[data-bf2-thumb]');
    thumb.src = line.image || '';
    thumb.alt = line.product_title || '';

    var indexEl = frag.querySelector('[data-bf2-index]');
    indexEl.textContent = 'Pair ' + slotNumber;

    var colorSelect = frag.querySelector('[data-bf2-color]');
    var sizeSelect = frag.querySelector('[data-bf2-size]');
    var priceEl = frag.querySelector('[data-bf2-price]');
    var current = lineColorSize(line);

    product.options[colorIdx].values.forEach(function (val) {
      var opt = document.createElement('option');
      opt.value = val;
      opt.textContent = val;
      if (val === current.color) opt.selected = true;
      colorSelect.appendChild(opt);
    });

    product.options[sizeIdx].values.forEach(function (val) {
      var opt = document.createElement('option');
      opt.value = val;
      opt.textContent = val;
      if (val === current.size) opt.selected = true;
      sizeSelect.appendChild(opt);
    });

    priceEl.textContent = formatPrice(line.final_price);

    colorSelect.addEventListener('change', function () { handleSlotVariantChange(card); });
    sizeSelect.addEventListener('change', function () { handleSlotVariantChange(card); });

    slotsEl.appendChild(frag);
  }

  function renderAllSlots(cart) {
    slotsEl.innerHTML = '';
    var lines = slotLinesFromCart(cart).slice().sort(function (a, b) {
      return Number(lineSlot(a)) - Number(lineSlot(b));
    });
    lines.forEach(function (line) {
      renderSlotCard(line, lineSlot(line));
    });
    updateTotals(cart);
    updateAddCards(cart);
  }

  function updateTotals(cart) {
    var totalsEl = document.getElementById('bf2-totals');
    if (!totalsEl) return;
    var badgeEl = document.getElementById('bf2-discount-badge');
    var compareEl = document.getElementById('bf2-compare-price');
    var finalEl = document.getElementById('bf2-final-price');

    var lines = slotLinesFromCart(cart);
    var count = lines.length;

    if (count === 0) { totalsEl.hidden = true; return; }

    var totalFinal = 0;
    var totalCompare = 0;
    lines.forEach(function (line) {
      totalFinal += line.final_price * line.quantity;
      totalCompare += (line.compare_at_price && line.compare_at_price > line.final_price
        ? line.compare_at_price
        : line.price) * line.quantity;
    });

    var pct = DISCOUNT_PCTS[count] || 36;
    if (badgeEl) badgeEl.textContent = pct + '% OFF';
    if (finalEl) finalEl.textContent = formatPrice(totalFinal);
    if (compareEl) {
      if (compareAtPerPair > 0) {
        totalCompare = compareAtPerPair * count;
      } else if (totalCompare <= totalFinal) {
        totalCompare = Math.round(totalFinal / (1 - pct / 100));
      }
      compareEl.textContent = formatPrice(totalCompare);
      compareEl.hidden = false;
    }
    totalsEl.hidden = false;
  }

  function updateAddCards(cart) {
    var count = slotLinesFromCart(cart).length;
    var addCardsEl = document.getElementById('bf2-add-cards');
    var card2 = document.getElementById('bf2-add-card-2');
    var card3 = document.getElementById('bf2-add-card-3');
    var btn3 = document.getElementById('bf2-add-card-3-btn');
    if (card2) card2.hidden = count >= 2;
    if (card3) {
      card3.hidden = count >= 3;
      var faded = count < 2;
      card3.classList.toggle('bf2-add-card--faded', faded);
      if (btn3) btn3.disabled = faded;
    }
    if (addCardsEl) addCardsEl.hidden = count >= MAX_SLOTS;
  }

  function handleSlotVariantChange(card) {
    var slotNumber = card.dataset.slot;
    var colorSelect = card.querySelector('[data-bf2-color]');
    var sizeSelect = card.querySelector('[data-bf2-size]');
    var priceEl = card.querySelector('[data-bf2-price]');
    var thumb = card.querySelector('[data-bf2-thumb]');

    var color = colorSelect.value;
    var size = sizeSelect.value;
    var variant = variantLookup[color] && variantLookup[color][size];

    if (!variant || !variant.available) {
      showError('That color/size combination is currently unavailable. Please choose another.');
      return;
    }

    enqueue(function () {
      return getCart().then(function (cart) {
        var oldLine = cart.items.find(function (i) { return lineSlot(i) === slotNumber; });
        if (!oldLine) throw new Error('slot_not_found');
        if (oldLine.variant_id === variant.id) return null; // already this variant

        var oldVariantId = oldLine.variant_id;
        return addToCart(variant.id, slotNumber)
          .then(function () { return getCart(); })
          .then(function (cartAfterAdd) {
            var staleLine = cartAfterAdd.items.find(function (i) {
              return lineSlot(i) === slotNumber && i.variant_id === oldVariantId;
            });
            if (!staleLine) return cartAfterAdd;
            var staleLineIndex = cartAfterAdd.items.indexOf(staleLine) + 1;
            return removeLine(staleLineIndex);
          });
      }).then(function (finalCart) {
        if (!finalCart) return;
        clearError();
        var newLine = finalCart.items.find(function (i) { return lineSlot(i) === slotNumber; });
        if (newLine) {
          priceEl.textContent = formatPrice(newLine.final_price);
          if (newLine.image) thumb.src = newLine.image;
        }
        updateTotals(finalCart);
      });
    }).catch(function () {
      showError('Something went wrong updating that item — please try again.');
    });
  }

  function handleAddSlot(targetSlot) {
    enqueue(function () {
      return addToCart(firstAvailableVariant.id, targetSlot)
        .then(function () { return getCart(); })
        .then(function (updatedCart) {
          clearError();
          renderAllSlots(updatedCart);
        });
    }).catch(function () {
      showError('Something went wrong adding another color — please try again.');
    });
  }

function getInitialQty() {
    var params = new URLSearchParams(window.location.search);
    var fromUrl = parseInt(params.get('qty'), 10);
    if (fromUrl > 0) return fromUrl;
    var fromStorage = parseInt(sessionStorage.getItem('bundleQty'), 10);
    if (fromStorage > 0) return fromStorage;
    return 1;
  }

  function init() {
    var qty = getInitialQty();

    fetchProduct(productHandle).then(function (prod) {
      product = prod;
      colorIdx = getOptionIndex(product, 'color');
      sizeIdx = getOptionIndex(product, 'size');
      if (colorIdx === null) colorIdx = 0;
      if (sizeIdx === null) sizeIdx = 1;
      variantLookup = buildVariantLookup(product);
      firstAvailableVariant = product.variants.find(function (v) { return v.available; });

      if (!firstAvailableVariant) {
        throw new Error('product_out_of_stock');
      }

      return getCart();
    }).then(function (cart) {
      var existingSlots = {};
      slotLinesFromCart(cart).forEach(function (l) { existingSlots[lineSlot(l)] = true; });

      var chain = Promise.resolve();
      for (var n = 1; n <= qty; n++) {
        if (!existingSlots[String(n)]) {
          (function (slotNum) {
            chain = chain.then(function () {
              return enqueue(function () { return addToCart(firstAvailableVariant.id, slotNum); });
            });
          })(n);
        }
      }

      // Trim slots left over from a previous visit with a higher qty (e.g.
      // customer went back to Step 1 and picked a lower tier) — re-resolves
      // each line's position fresh right before removing it, since earlier
      // removals in this same chain shift subsequent line indexes.
      var excessSlotNumbers = Object.keys(existingSlots)
        .map(Number)
        .filter(function (n) { return n > qty; });
      excessSlotNumbers.forEach(function (slotNum) {
        chain = chain.then(function () {
          return enqueue(function () {
            return getCart().then(function (freshCart) {
              var line = freshCart.items.find(function (i) { return lineSlot(i) === String(slotNum); });
              if (!line) return null;
              var lineIndex = freshCart.items.indexOf(line) + 1;
              return removeLine(lineIndex);
            });
          });
        });
      });

      return chain;
    }).then(function () {
      return getCart();
    }).then(function (finalCart) {
      renderAllSlots(finalCart);
      skeletonEl.hidden = true;
      slotsEl.hidden = false;
    }).catch(function (err) {
      var message = err && err.message === 'product_out_of_stock'
        ? 'This product is currently out of stock.'
        : 'Something went wrong loading your bundle — please refresh the page.';
      showError(message);
      skeletonEl.hidden = true;
    });
  }

  var card2Btn = document.getElementById('bf2-add-card-2-btn');
  var card3Btn = document.getElementById('bf2-add-card-3-btn');
  if (card2Btn) card2Btn.addEventListener('click', function () { handleAddSlot(2); });
  if (card3Btn) card3Btn.addEventListener('click', function () { handleAddSlot(3); });

  // Keep bottom padding equal to sticky footer height so content is never hidden behind it
  (function () {
    var footer = document.querySelector('.bf2-sticky-footer');
    var col = document.querySelector('.bf2-col-main');
    if (!footer || !col) return;
    function syncPadding() {
      if (window.innerWidth < 900) {
        col.style.paddingBottom = (footer.offsetHeight + 16) + 'px';
      } else {
        col.style.paddingBottom = '';
      }
    }
    syncPadding();
    window.addEventListener('resize', syncPadding);
    new MutationObserver(syncPadding).observe(footer, { childList: true, subtree: true, attributes: true });
  })();

  // 10-minute looping countdown — resets automatically when it hits 0
  (function () {
    var timerEl = document.getElementById('bf2-timer');
    if (!timerEl) return;
    var total = 10 * 60;
    var seconds = total;
    function render() {
      var m = Math.floor(seconds / 60);
      var s = seconds % 60;
      timerEl.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    }
    render();
    setInterval(function () {
      seconds--;
      if (seconds < 0) seconds = total;
      render();
    }, 1000);
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
